import React from "react";
import LoginForm from "./components/LoginForm";

const UnauthenticatedApp = () => {
  return (
    <LoginForm />
  );
};

export default UnauthenticatedApp;
